// in case this was queried for before that initial mount of the controller then
// we also need to take into account existing URL
const isUsingEmulator = () =>
    sessionStorage.getItem('useEmulator') === 'true' ||
    new URL(window.location.href).searchParams.get('emulator') !== null

export default isUsingEmulator
